// extracted by mini-css-extract-plugin
export default {"imageWrapper":"rI-z","twoColumnImage":"sI-z"};